import{a as m}from"./chunk-RAAYCPUM.js";function u(...n){return m(i,n)}var i=(n,{min:e,max:r})=>e!==void 0&&n<e?e:r!==void 0&&n>r?r:n;export{u as a};
